import { WebContainer } from '@webcontainer/api';
import { createContext, useContext } from 'react';

interface WebContainerContextType {
  webContainer: WebContainer | null;
  iframeSrc: string;
}

export const WebContainerContext = createContext<WebContainerContextType>({
  webContainer: null,
  iframeSrc: '',
});

export const useWebContainer = () => useContext(WebContainerContext);
